import Marquee from "react-fast-marquee";

const items = [
  "Web Design",
  "SEO Optimization",
  "Hosting Setup",
  "E-Commerce",
  "Lead Capture",
  "Speed Optimization",
  "Branding",
  "CMS Integration",
  "Maintenance",
  "Analytics",
  "Payment Gateways",
  "Custom Animations",
];

export default function ServicesMarquee() {
  return (
    <section className="py-10 border-y border-white/10 bg-[#0a0a0a] overflow-hidden">
      <Marquee speed={45} gradient={false} pauseOnHover>
        {items.map((it, i) => (
          <div
            key={i}
            className="flex items-center gap-6 mx-8 font-display text-3xl md:text-5xl font-black"
          >
            <span className="text-zinc-700 hover:text-[#CCFF00] transition-colors uppercase tracking-tight">
              {it}
            </span>
            <span className="text-[#CCFF00] text-2xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
